var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-pagination',{staticClass:"dsn-pagination",attrs:{"layout":_vm.layout,"total":_vm.total,"page-size":_vm.pageSize,"current-page":_vm.currentPage},on:{"current-change":_vm.currentChange,"size-change":_vm.sizeChange}})}
var staticRenderFns = []

export { render, staticRenderFns }